import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AppService } from "../../core/services/app.service";
import { BehaviorSubject, Observable } from "rxjs";
import { switchMap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class LoadingService {
  private isLoading = new BehaviorSubject<boolean>(false);

  constructor() {}

  setLoading(isLoading: boolean) {
    this.isLoading.next(isLoading);
  }

  getLoading() {
    return this.isLoading.asObservable();
  }

  start() {
    this.setLoading(true);
  }

  complete() {
    this.setLoading(false);
  }
}
